import {
  ACCOUNT_ACTIVATION_PREFIX,
  FORGOT_PASSWORD_PREFIX,
  HHMT_ACOUNT_ACTIVATION_TITLE,
  HHMT_FORGOT_PASSWORD_TITLE,
  HHMT_LOGIN_TITLE,
  HHMT_REGISTRATION_TITLE,
  HHMT_RESET_PASSWORD_TITLE,
  HHMT_TITLE,
  LOGIN_PREFIX,
  NOT_FOUND_PREFIX,
  NOT_FOUND_TITLE,
  REGISTER_PREFIX,
  REMOX_ACOUNT_ACTIVATION_TITLE,
  REMOX_FORGOT_PASSWORD_TITLE,
  REMOX_LOGIN_TITLE,
  REMOX_REGISTRATION_TITLE,
  REMOX_RESET_PASSWORD_TITLE,
  REMOX_TITLE,
  RESET_PASSWORD_PREFIX,
} from 'constants';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { domUtils } from 'utils';
import useTheme from './useTheme';

const useAddDocumentTitle = () => {
  const { isHHMTTheme } = useTheme();
  const { pathname } = useLocation();

  const getDocumentTitleReference = (pathname) => {
    if (pathname.includes(RESET_PASSWORD_PREFIX)) {
      return isHHMTTheme
        ? HHMT_RESET_PASSWORD_TITLE
        : REMOX_RESET_PASSWORD_TITLE;
    }

    if (pathname.includes(ACCOUNT_ACTIVATION_PREFIX)) {
      return isHHMTTheme
        ? HHMT_ACOUNT_ACTIVATION_TITLE
        : REMOX_ACOUNT_ACTIVATION_TITLE;
    }

    if (pathname.includes(LOGIN_PREFIX)) {
      return isHHMTTheme ? HHMT_LOGIN_TITLE : REMOX_LOGIN_TITLE;
    }

    if (pathname.includes(FORGOT_PASSWORD_PREFIX)) {
      return isHHMTTheme
        ? HHMT_FORGOT_PASSWORD_TITLE
        : REMOX_FORGOT_PASSWORD_TITLE;
    }

    if (pathname.includes(NOT_FOUND_PREFIX)) {
      return NOT_FOUND_TITLE;
    }

    if (pathname.includes(REGISTER_PREFIX)) {
      return isHHMTTheme ? HHMT_REGISTRATION_TITLE : REMOX_REGISTRATION_TITLE;
    }

    return isHHMTTheme ? HHMT_TITLE : REMOX_TITLE;
  };
  useEffect(() => {
    domUtils.addDocumentTitle(getDocumentTitleReference(pathname));
  }, [pathname]);
};

export default useAddDocumentTitle;
